import { OnboardingVersionType } from '../states/OnboardingProvider';
import { InitialOnboardingSteps } from '../constants/content';

export const getOnboardingStepName = (version: OnboardingVersionType, index: number): string => {
  return InitialOnboardingSteps[`v${version}`][index].content.stepName;
};
